<template>
  <div>
    <div v-if="showAlertPanel && alertList.length > 0" class="alert-panel">
      <div class="alert-header">
        <h4 class="alert-title">报警</h4>
      </div>
      <div class="alert-content" ref="alertContent" @mouseenter="stopAutoScroll" @mouseleave="startAutoScroll">
        <div class="scroll-container">
          <div class="alert-item" v-for="(alert, index) in alertList" :key="index"
            @mouseenter="showTooltip($event, alert)" @mouseleave="hideTooltip" @click="goToAlarmManagement">
            <span class="alert-time" :class="{ 'warning-text': alert.alarmLevel === '预警' }">
              {{ alert.msgAddress }} - {{ alert.flowMeterNo }} - {{ alert.alarmType }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 悬浮提示框 - 移到组件外部 -->
    <div v-if="tooltip.visible" class="tooltip" :style="tooltip.style">
      <div class="tooltip-content">
        <div class="tooltip-title">{{ formatFullTime(tooltip.data.collectTime) }}</div>
        <div class="tooltip-message">{{ tooltip.data.msgAddress }} - {{ tooltip.data.flowMeterNo }} - {{
          tooltip.data.alarmType }}</div>
        <div class="tooltip-details">
          <div>设备编号: {{ tooltip.data.flowMeterNo ? tooltip.data.flowMeterNo : 'N/A' }}</div>
          <div>报警级别: {{ tooltip.data.alarmLevel || '未知' }}</div>
          <div>报警类型: {{ tooltip.data.alarmType || '未知' }}</div>
          <div>报警值: {{ tooltip.data.alarmValue || 'N/A' }}</div>
          <div>参考值: {{ tooltip.data.refValue || 'N/A' }}</div>
          <div>安装地址: {{ tooltip.data.msgAddress || 'N/A' }}</div>
          <div>处理状态: 待处理</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertPanel',
  data () {
    return {
      showAlertPanel: false,
      alertList: [],
      scrollTimer: null,
      tooltip: {
        visible: false,
        data: {},
        style: {}
      }
    }
  },
  mounted () {
    this.startAutoScroll();
    this.getAlarmData();
  },
  beforeDestroy () {
    this.stopAutoScroll();
  },
  methods: {
    startAutoScroll () {
      this.scrollTimer = setInterval(() => {
        const content = this.$refs.alertContent;
        if (content) {
          content.scrollTop += 1; // 增加滚动速度
          // 没有复制内容时：滚到底再回到顶部（避免超出范围）
          const maxScrollTop = content.scrollHeight - content.clientHeight;
          if (maxScrollTop > 0 && content.scrollTop >= maxScrollTop) {
            content.scrollTop = 0;
          }
        }
      }, 50); // 每50ms滚动1px
    },
    stopAutoScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    showTooltip (event, alert) {
      this.tooltip.data = alert;
      this.tooltip.visible = true;

      // 计算tooltip位置 - 使用固定定位
      const rect = event.target.getBoundingClientRect();

      this.tooltip.style = {
        position: 'fixed',
        left: `${rect.right + 10}px`,
        top: `${rect.top}px`,
        zIndex: 9999
      };
    },
    hideTooltip () {
      this.tooltip.visible = false;
    },
    getAlertLevel (message) {
      if (message.includes('异常') || message.includes('故障')) {
        return '高';
      } else if (message.includes('超限') || message.includes('离线')) {
        return '中';
      } else {
        return '低';
      }
    },
    // 获取报警数据
    async getAlarmData () {
      try {
        const response = await this.$http.get('/pipe-network/remote_water_meter_alarm_messages/list', {
          params: {
            sysTab: 1,
            isDispose: 0
          }
        });

        if (response.data) {
          // 合并一小时和六小时的报警数据
          const allAlarms = [
            ...(response.data.anHourList || []),
            ...(response.data.sixHoursList || [])
          ];

          // 转换数据格式
          this.alertList = allAlarms.map(alarm => ({
            time: this.formatTime(alarm.collectTime),
            message: `${this.formatTime(alarm.collectTime)} - ${alarm.flowMeterName} - ${alarm.alarmContent}`,
            collectTime: alarm.collectTime,
            alarmLevel: alarm.alarmLevel,
            alarmType: alarm.alarmType,
            alarmValue: alarm.alarmValue,
            refValue: alarm.refValue,
            msgAddress: alarm.msgAddress,
            flowMeterNo: alarm.flowMeterNo
          }));

          // 只有在有报警数据时才显示面板
          this.showAlertPanel = this.alertList.length > 0;

          console.log('报警数据加载完成:', this.alertList);
        }
      } catch (error) {
        console.error('获取报警数据失败:', error);
        // 如果API失败，不显示面板
        this.alertList = [];
        this.showAlertPanel = false;
      }
    },
    // 格式化时间
    formatTime (timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    // 格式化完整时间
    formatFullTime (timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 跳转到报警管理页面
    goToAlarmManagement () {
      this.$router.push({ path: '/pressure-alarm-management/pressure-alarm-list' });
    }
  }
}
</script>

<style lang="less" scoped>
// 报警面板样式
.alert-panel {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 298px;
  height: 236px;
  background:
    url('../../../../assets/pressure/bj.png') no-repeat center center;
  background-size: cover;

  border-radius: 8px;
  z-index: 1001;
  overflow: hidden;

}

.alert-header {
  position: relative;
  padding: 28px 16px 8px 70px;
}

.alert-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

.alert-content {
  margin-top: 20px;
  max-height: 130px;
  position: absolute;
  top: 45px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  padding: 10px 25px;
  overflow-y: auto;
  z-index: 5;
  /* 自定义滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.scroll-container {
  /* 确保内容可以无缝循环 */
  position: relative;
}

.alert-content::-webkit-scrollbar {
  width: 4px;
}

.alert-content::-webkit-scrollbar-track {
  background: transparent;
}

.alert-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.alert-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.alert-item {
  display: flex;
  margin-bottom: 4px;
  align-items: flex-start;
  padding: 4px 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.alert-item:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.alert-item:last-child {
  margin-bottom: 0;
}

.alert-time {
  flex: 1;
  font-size: 12px;
  color: #ff6b6b;
  text-shadow: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.warning-text {
  color: #FFA509 !important;
}


// 悬浮提示框样式
.tooltip {
  background: rgba(0, 0, 0, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  animation: fadeIn 0.2s ease;
  pointer-events: none;
  /* 防止tooltip阻挡鼠标事件 */
}

.tooltip-content {
  padding: 12px;
  min-width: 200px;
}

.tooltip-title {
  font-size: 14px;
  font-weight: 600;
  color: #ff6b6b;
  margin-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 4px;
}

.tooltip-message {
  font-size: 13px;
  color: #ffffff;
  margin-bottom: 8px;
  font-weight: 500;
}

.tooltip-details {
  font-size: 11px;
  color: #cccccc;
  line-height: 1.4;
}

.tooltip-details div {
  margin-bottom: 2px;
}

.tooltip-details div:last-child {
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .alert-panel {
    width: 250px;
    height: 180px;
    top: 10px;
    left: 10px;
  }

  .tooltip {
    min-width: 180px;
  }
}
</style>
